import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import Layout from '../components/Layout'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import ContactForm from '../components/ContactForm'
import SEO from '../components/SEO'

const Contact = ({ data }) => {
  const postNode = {
    title: `How To Join - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <Helmet>
        <title>{`How To Join - ${config.siteTitle}`}</title>
      </Helmet>
      <SEO postNode={postNode} pagePath="contact" customTitle />

      <Container>
        <PageTitle>How To Join</PageTitle>
        <p>Interested in becoming a firefighter and helping out your community?  Please fill out the form below and someone will contact you with more information.</p>
        <p>&nbsp;</p>
        <ContactForm />
      </Container>
    </Layout>
  )
}

export default Contact
